<template>
  <div>
    <img src="@/assets/tarjeta_ofertas_seguro_negocios.jpg" style="width: 100%" />
    <p class="tituloTarjeta">SEGURO DE NEGOCIOS</p>
    <p>
      Un seguro completo y multirriesgo para proteger tu oficina o comercio a medida con la mayor personalización.
    </p>
    <ul style="list-style-type: disc">
      <li>Personalizable.</li>
      <li>Indemnización por interrupción de la actividad.</li>
      <li>Protege tu patrimonio ante todo lo que pueda surgir en tu negocio.</li>
      <li>Servicios adicionales para mantener y cuidar tu actividad comercial.</li>
    </ul>
    <p>¡Tu negocio protegido con la mejor calidad!</p>
    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button class="pure-button botonLlamar" title="Pulsa el botón para llamar a tu oficina MMT">
          Llama e infórmate
        </button>
      </a>
    </p>



  </div>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },


};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 13rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

// .container-flex a:first-child {
//   margin-right: 15%;
// }
</style>
